import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { SxProps, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useIsAdmin } from "@src/api/user-auths/is-admin";

type Props = {
  sx?: SxProps;
};

export const VersionDisplay = (props: Props) => {
  const theme = useTheme();
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return null;
  }

  const versionString = `${__REVISION__}-${__BUILD_TIME__}`;

  return (
    <Grid id="ig-version-info" container justifyContent={"center"}>
      <IgTypography variant="body2" color={theme.palette.text.secondary}>
        Rev. {versionString}
      </IgTypography>
    </Grid>
  );
};
